__turbopack_context__.v({
  "category": "Filters-module-scss-module__zU7R2G__category",
  "fade-in": "Filters-module-scss-module__zU7R2G__fade-in",
  "inner": "Filters-module-scss-module__zU7R2G__inner",
  "items": "Filters-module-scss-module__zU7R2G__items",
  "root": "Filters-module-scss-module__zU7R2G__root",
  "title": "Filters-module-scss-module__zU7R2G__title",
});
